export const CLOSE_TEMPLATE_REVIEW_FIELDS = [
    "category",
    "counterparty",
    "ledger",
    "accrual_ledger",
    "entity",
    "class",
    "note",
] as const;

export type CloseTemplateReviewField =
    (typeof CLOSE_TEMPLATE_REVIEW_FIELDS)[number];
